import { usePage } from "@inertiajs/react"

interface PageProps {
  flash?: { notice?: string; alert?: string }
  [key: string]: unknown
}

// layouts/application rendered Notifications::Component per flash entry inside
// `#notifications`; layouts/inertia has no equivalent, so a successful
// POST /send_message would redirect to the home page with nothing shown. The
// four Kenjosset pages include this so the notice survives the redirect.
export default function Flash() {
  const { props } = usePage<PageProps>()
  const flash = props.flash ?? {}
  const messages = [flash.notice, flash.alert].filter(
    (message): message is string => typeof message === "string" && message.length > 0
  )

  if (messages.length === 0) return null

  return (
    <div id="notifications" className="fixed bottom-10 left-10 z-50 w-96">
      {messages.map((message) => (
        <div
          key={message}
          role="status"
          className="max-w-sm w-full text-contrast bg-form-input shadow-lg rounded-lg pointer-events-auto mt-0 sm:mt-4"
        >
          <div className="rounded-lg shadow-xs overflow-hidden">
            <div className="p-4">
              <p className="text-sm leading-5 font-medium text-contrast">{message}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
